import { StateCreator } from 'zustand';

export interface LocaleSlice {
  locale?: string;
  setLocale: (locale: string) => void;
}

export const createLocaleSlice: StateCreator<LocaleSlice> = (set) => ({
  locale: undefined,
  setLocale: (locale: string) => set({ locale }),
});
